export default __webpack_public_path__ + "static/media/parts.e5d2734e.png";